// import { useEffect } from "react";

// export default function HilltopAdZone() {
//   useEffect(() => {
//     const script = document.createElement("script");
//     script.innerHTML = `
//       (function(nwto){
//         var d = document,
//             s = d.createElement('script'),
//             l = d.scripts[d.scripts.length - 1];
//         s.settings = nwto || {};
//         s.src = "//tatteredpassenger.com/bUXAVcs.dfG_lG0aYdW/ce/geYm/9IuOZNU/llktPhTqYZ2iOADDkM0/Nzj/cytpNRjuY/4FOmT/QZ2jOnAC";
//         s.async = true;
//         s.referrerPolicy = 'no-referrer-when-downgrade';
//         l.parentNode.insertBefore(s, l);
//       })({});
//     `;
//     script.type = "text/javascript";
//     document.body.appendChild(script);

//     return () => {
//       // optional cleanup
//       script.remove();
//     };
//   }, []);

//   return (
//     <div
//       className="my-3 text-center"
//       style={{
//         minHeight: "600px",
//         border: "1px solid #eee",
//         padding: "10px",
//         background: "#f9f9f9",
//         width: "300px"
//       }}
//     >
//       Ad loading...
//     </div>
//   );
// }

import { useEffect, useRef } from "react";

export default function HilltopAdZone({ zoneSrc }) {
  const adRef = useRef(null);

  useEffect(() => {
    const container = adRef.current;
    if (!container || !zoneSrc) return;

    // Clear any previous ad if component re-renders with new key
    container.innerHTML = "";

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.referrerPolicy = "no-referrer-when-downgrade";
    script.src = zoneSrc; // ✅ Dynamic key here

    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [zoneSrc]); // re-run when key changes

  return (
    <div
      ref={adRef}
      className="my-3 text-center hilltop-ad-slot"
      style={{
        minHeight: "250px",
        border: "1px dashed #ccc",
        backgroundColor: "#f9f9f9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span>Loading ad…</span>
    </div>
  );
}
